import { FiltersMap } from '@wix/bex-core';

export type StatusFilters = FiltersMap & {};
